// 状态选择
export const StatusOptionEnmus = [
	{
		value: 0,
		label: '否'
	}, {
		value: 1,
		label: '是'
	}]

// 有效状态的显示
export const StatusValidDisplayEnmus = [
	{
		value: 1,
		label: '有效'
	}, {
		value: 0,
		label: '无效'
	}
]

export const MenuType = [
	{
		value: 0,
		label: '功能'
	}, {
		value: 1,
		label: '菜单'
	}
]
export const CopartnerStateEnmus = [
	{
		value: -1,
		label: '全部'
	}, {
		value: 1,
		label: '已启用'
	}, {
		value: 0,
		label: '已禁用'
	}
]

export const ProjectStageEnmus = [
	{
		value: 1,
		label: '项目启动'
	},
	{
		value: 2,
		label: '需求阶段'
	},
	{
		value: 3,
		label: '研发阶段'
	},
	{
		value: 4,
		label: '测试阶段'
	},
	{
		value: 5,
		label: '验收阶段'
	},
	{
		value: 6,
		label: '维护阶段'
	},
	{
		value: 7,
		label: '项目关闭'
	},
]


// WEBPACK FOOTER //
// ./src/utils/enmus.js